import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { ref, get, onValue } from 'firebase/database';
import { auth, database } from './firebase';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import './index.css';

function PrivateRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [blockedMessage, setBlockedMessage] = useState('');
  const AUTHORIZED_EMAIL = 'danielinvestigador@gmail.com';

  useEffect(() => {
    let userBlockedListener = null;

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        if (currentUser.email && currentUser.email.toLowerCase() === AUTHORIZED_EMAIL.toLowerCase()) {
          // Verificar se o usuário está bloqueado
          const userId = currentUser.uid;
          const userEmail = currentUser.email;
          
          try {
            // Tentar buscar por UID primeiro
            let userRef = ref(database, `users/${userId}`);
            let userSnapshot = await get(userRef);
            let userData = null;
            let actualUserKey = userId;
            
            // Se não encontrar por UID, buscar por email
            if (!userSnapshot.exists()) {
              const usersRef = ref(database, 'users');
              const allUsersSnapshot = await get(usersRef);
              if (allUsersSnapshot.exists()) {
                const allUsers = allUsersSnapshot.val();
                // Procurar usuário por email
                for (const [key, user] of Object.entries(allUsers)) {
                  if (user && user.email && user.email.toLowerCase() === userEmail.toLowerCase()) {
                    userData = user;
                    actualUserKey = key;
                    userRef = ref(database, `users/${key}`);
                    break;
                  }
                }
              }
            } else {
              userData = userSnapshot.val();
            }
            
            // Verificar se está bloqueado (verifica boolean true, string "true", ou 1)
            if (userData && (userData.blocked === true || userData.blocked === 'true' || userData.blocked === 1)) {
              console.warn(`Usuário bloqueado: ${currentUser.email}`);
              await signOut(auth);
              setBlockedMessage('Sua conta foi bloqueada. Entre em contato com o administrador.');
              setUser(null);
              setLoading(false);
              return;
            }

            // Configurar listener para monitorar mudanças no status de bloqueio
            userBlockedListener = onValue(userRef, async (snapshot) => {
              if (snapshot.exists()) {
                const userData = snapshot.val();
                // Verificar se está bloqueado (verifica boolean true, string "true", ou 1)
                if (userData && (userData.blocked === true || userData.blocked === 'true' || userData.blocked === 1)) {
                  console.warn(`Usuário foi bloqueado durante a sessão: ${currentUser.email}`);
                  setBlockedMessage('Sua conta foi bloqueada. Você será desconectado.');
                  await signOut(auth);
                  setUser(null);
                }
              }
            });
          } catch (error) {
            console.error('Erro ao verificar status de bloqueio:', error);
          }

          setUser(currentUser);
        } else {
          console.warn(`Acesso negado para: ${currentUser.email}. Apenas ${AUTHORIZED_EMAIL} é permitido.`);
          await signOut(auth);
          setUser(null);
        }
      } else {
        setUser(null);
        // Limpar listener quando usuário não está autenticado
        if (userBlockedListener) {
          userBlockedListener();
          userBlockedListener = null;
        }
      }
      setLoading(false);
    });

    return () => {
      unsubscribe();
      if (userBlockedListener) {
        userBlockedListener();
      }
    };
  }, []);

  if (loading) return <div style={{ color: 'white', textAlign: 'center', marginTop: '20%' }}>Carregando...</div>;

  if (blockedMessage) {
    return (
      <div style={{ 
        color: 'white', 
        textAlign: 'center', 
        marginTop: '20%',
        padding: '2rem',
        background: 'rgba(239, 68, 68, 0.1)',
        borderRadius: '8px',
        maxWidth: '500px',
        margin: '20% auto',
        border: '1px solid rgba(239, 68, 68, 0.3)'
      }}>
        <div style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>🚫</div>
        <div style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.5rem' }}>Acesso Bloqueado</div>
        <div>{blockedMessage}</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
